import { useEffect } from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import { useLocation } from "react-router-dom";
import { ConnectModalProvider } from "@/context/ConnectModalContext";

// The Arise & Echo page is a separate venture and keeps its original
// fade-in behaviour. Every other page loads static.
const LEGACY_MOTION_PATHS = ["/arise-and-echo"];

export default function Layout({ children }) {
  const { pathname } = useLocation();
  const legacy = LEGACY_MOTION_PATHS.includes(pathname);

  useEffect(() => {
    const on = () => document.body.classList.toggle("is-scrolled", window.scrollY > 8);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => { window.removeEventListener("scroll", on); document.body.classList.remove("is-scrolled"); };
  }, []);

  return (
    <ConnectModalProvider>
      <a href="#main" className="hp-skip">Skip to content</a>
      <Nav />
      <main id="main" key={pathname} className={`${legacy ? "page-fade legacy-motion" : ""} pt-[71px] md:pt-[79px] bg-white`}>
        {children}
      </main>
      <Footer />
      <WhatsAppFab />
    </ConnectModalProvider>
  );
}
